import { fontWeight } from './fontWeight.js';
export { fontWeight } from './fontWeight.js';
import { generator, compose, getColor, getFontFamily, getFontSize, getLetterSpacing, getLineHeight } from './theme.js';
import { toPx } from './unit.js';

const color = (props) => generator({
    props,
    prop: ['color', 'c'],
    cssProperty: 'color',
    getter: getColor,
});
const fontFamily = (props) => generator({
    props,
    prop: ['fontFamily'],
    cssProperty: 'font-family',
    getter: getFontFamily,
});
const fontSize = (props) => generator({
    props,
    prop: ['fontSize'],
    cssProperty: 'font-size',
    getter: getFontSize,
    transform: toPx,
});
const letterSpacing = (props) => generator({
    props,
    prop: ['letterSpacing'],
    cssProperty: 'letter-spacing',
    getter: getLetterSpacing,
    transform: toPx,
});
const lineHeight = (props) => generator({
    props,
    prop: ['lineHeight'],
    cssProperty: 'line-height',
    getter: getLineHeight,
    transform: toPx,
});
const textAlign = (props) => generator({
    props,
    prop: ['textAlign'],
    cssProperty: 'text-align',
});
const textOverflow = (props) => generator({
    props,
    prop: ['textOverflow'],
    cssProperty: 'text-overflow',
});
const textTransform = (props) => generator({
    props,
    prop: ['textTransform'],
    cssProperty: 'text-transform',
});
const typography = compose(color, fontFamily, fontSize, fontWeight, letterSpacing, lineHeight, textAlign, textOverflow, textTransform);

export { color, fontFamily, fontSize, letterSpacing, lineHeight, textAlign, textOverflow, textTransform, typography };
